import { Directive, ElementRef, Renderer2, OnInit, AfterViewInit, OnDestroy, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { CmsMenuActionsService } from '../../../../store/actions/cms-menu.actions';
import { Subscription } from 'rxjs';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../../../../interfaces/store.interface';

@Directive({
    selector: '[menuSizer]'
})
export class MenuSizerDirective implements OnInit, OnChanges, AfterViewInit, OnDestroy {

    isMobile: boolean;

    currentMenuWrapIndex: number;

    cmsMenuWrapIndexSubscription = Subscription.EMPTY;

    constructor(
        private el: ElementRef,
        private ngRedux: NgRedux<AppState>,
        private cmsMenuActionsService: CmsMenuActionsService
    ) { }

    @HostListener('window:resize', [])
    onResize() {
        this.init();
    }

    ngOnInit(): void {

        this.cmsMenuWrapIndexSubscription = this.ngRedux.select<number>(['cmsMenu', 'wrapIndex'])
            .subscribe((response) => {
                this.currentMenuWrapIndex = response;
            });

    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    ngAfterViewInit(): void {
        this.init(true);
    }

    ngOnDestroy(): void {
        this.cmsMenuWrapIndexSubscription.unsubscribe();
    }

    init(firstInit = false) {
        window.setTimeout(() => { this.processDesktop(); });
    }

    private processDesktop() {

        // get hidden menu size
        const navUlEls = this.el.nativeElement.querySelectorAll('.navigation__list');

        if (!navUlEls || navUlEls.length === 0) {
            return;
        }

        // total available size to insert menu elements
        const menuTotalSize = navUlEls[1].offsetWidth;

        const hiddenNavUlEl = navUlEls[0];
        const navUlEl = navUlEls[1];

        // select all nav items from real navigation bar
        let navLiEls = navUlEl.querySelectorAll('.navigation__item');
        // exclude the dynamic insert items
        navLiEls = Array.from(navLiEls).filter((li: any) => {
            return !Array.from(li.classList).includes('navigation__cms-item');
        });

        // get only the dynamic inserted items
        const additionalSubmenuEl = navLiEls.filter((li: any) => {
            return Array.from(li.classList).includes('navigation__cms-item-wrapper');
        });
        // total additional dynamic items occupied space
        const additionalMenuWidth = additionalSubmenuEl && additionalSubmenuEl.length === 1 ? additionalSubmenuEl[0].offsetWidth : 0;

        // calculate the static items needed space
        let totalLiWidths = 0;
        let fullLoaded = true;
        for (let x = 0; x < navLiEls.length; ++x) {
            totalLiWidths += navLiEls[x].offsetWidth + 2; // (+2) add some space for each element. Unloaded font issue?
            if (!navLiEls[x].innerText) {
                fullLoaded = false;
                break;
            }
        }
        // IE/EDGE workaround. In some cases the content is not loaded when this directive runs
        if (!fullLoaded) {
            window.setTimeout(() => { this.processDesktop(); }, 100);
            return;
        }

        // get all nav items from hidden menu
        const hiddenNavLiEls = hiddenNavUlEl.querySelectorAll('.navigation__item');

        // add a single item to menu and calculate if it exceeds
        let exceed = false;
        let exceedIndex = 0;
        let exceedCalculation = totalLiWidths - additionalMenuWidth;

        for (; !exceed && exceedIndex < hiddenNavLiEls.length; ++exceedIndex) {
            exceedCalculation += hiddenNavLiEls[exceedIndex].offsetWidth;
            exceed = menuTotalSize - (exceedCalculation + 34) < 0;
        }

        this.moveElementsToAdditionalMenu((exceed ? exceedIndex - 1 : exceedIndex));

    }

    private processMobile() {

    }

    private moveElementsToAdditionalMenu(elementsToMove) {
        this.cmsMenuActionsService.setMenuWrapIndex(elementsToMove);
    }
}
